import { z } from 'zod/v4';

const booleanLike = z
  .union([z.boolean(), z.string()])
  .optional()
  .transform(v => v === true || v === 'true');

export const ListUserCompaniesByCompanyIdsQuerySchema = z.object({
  companyIds: z.string().min(1, 'companyIds is required'),
  notAdmin: booleanLike,
});

export type ListUserCompaniesByCompanyIdsQuery = z.infer<
  typeof ListUserCompaniesByCompanyIdsQuerySchema
>;

export const UserCompanyByCompanyIdRowSchema = z.object({
  id: z.string(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  companyId: z.string(),
  isBlocked: z.number(),
  developmentTag: z.string().nullable(),
  hasAgreedWithTerms: z.boolean(),
  emailPreferences: z.unknown().nullable(),
  // Only present when `notAdmin=true` was requested.
  email: z.string().optional(),
});

export type UserCompanyByCompanyIdRow = z.infer<
  typeof UserCompanyByCompanyIdRowSchema
>;

// Bare array — no `{data, meta}` envelope. Matches the legacy
// `reply.code(200).send(result)` shape both frontend consumers expect.
export const ListUserCompaniesByCompanyIdsResponseSchema = z.array(
  UserCompanyByCompanyIdRowSchema,
);

export type ListUserCompaniesByCompanyIdsResponse = z.infer<
  typeof ListUserCompaniesByCompanyIdsResponseSchema
>;
